import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取店铺信息列表
    GET_SHOP_INFO(data) {
        controller='Shop';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_SHOP_INFO", data: data }); 
    },

    //编辑店铺信息
    EDIT_SHOP_INFO(data) {
        controller='Shop';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "EDIT_SHOP_INFO", data: data }); 
    },

    //获取店铺修改记录
    EDIT_SHOP_LOG(data) {
        controller='Shop';
        action='index';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "EDIT_SHOP_LOG", data: data }); 
    },

    //获取平台店铺信息
    GET_PLATFORM_SHOP(data) {
        controller='Platshop';
        action='GetShopList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增账号信息
    ADD_PLATFORM_SHOP(data) {
        controller='Platshop';
        action='AddShop';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除账号信息
    DEL_SHOPS(data) {
        controller='Platshop';
        action='DelShop';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取账号详细信息
    GET_SHOPS_FROM_IDS(data) {
        controller='Platshop';
        action='GetShopInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //编辑账号信息
    EDIT_PLATFORM_SHOP(data) {
        controller='Platshop';
        action='UpdateShops';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取系统菜单信息
    GET_PLATFORM_MENUS(data) {
        controller='Platshop';
        action='GetSysMenus';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除菜单
    DEL_PLATFORM_MENUS(data) {
        controller='Platshop';
        action='DelSysMenus';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增、编辑系统菜单
    ADD_OR_EDIT_PLATFROM_MENU(data) {
        controller='Platshop';
        action='AddOrEditSysMenu';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取账号级别信息
    GET_PLATFORM_Level(data) {
        controller='Platshop';
        action='GetSysLevel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增系统版本
    ADD_PLATFORM_LEVEL(data) {
        controller='Platshop';
        action='AddLevel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除系统版本
    DEL_SHOP_LEVEL(data) {
        controller='Platshop';
        action='DelLevel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取系统版本信息详情
    GET_PLATFORM_LEVEL_DETAIL(data) {
        controller='Platshop';
        action='GetLevelDetails';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //编辑账号版本信息
    EDIT_PLATFORM_LEVEL(data) {
        controller='Platshop';
        action='EditLevel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取版本权限信息
    GET_LEVEL_AUTH(data) {
        controller='Platshop';
        action='GetLevelAuth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //保存版本信息
    UPDATE_LEVEL_AUTH(data) {
        controller='Platshop';
        action='UpdateLevelAuth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取付费版本信息
    GET_AUTH_RENEW(data) {
        controller='Platshop';
        action='GetRenewMenuList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取跟进记录类型
    GET_PLATFORM_FOLLOW_TYPE(data) {
        controller='Platshop';
        action='GetShopFollowType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取跟进记录数据
    GET_PLATFORM_SHOP_FOLLOW(data) {
        controller='Platshop';
        action='GetShopFollow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增跟进记录数据
    ADD_FOLLOW(data) {
        controller='Platshop';
        action='AddFollow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}